import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SimpleDateFormatPipe } from "./simple-date-format.pipe";
import { TruncatePipe } from "./truncate.pipe";
import { SafeHtmlPipe } from "./safe-html.pipe";

@NgModule({
  imports: [CommonModule],
  exports: [SimpleDateFormatPipe, TruncatePipe],
  declarations: [SimpleDateFormatPipe, TruncatePipe, SafeHtmlPipe]
})
export class SharedPipesModule {}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/pipes/shared-pipes.module.ts